export default __webpack_public_path__ + "static/media/banner-finance-mobile-comp.bfd0eb95.jpg";